/* ⚛ REACT */
import React from "react";

/* 🎨 STYLES */
import { ItemButton, MenuIcon } from "./styles";

function ItemContainer({icon, text, ClickFunction, disabled, select, active, children, page}) {
    const childs = React.Children.toArray(children);
    return (
        <ItemButton disabled={disabled} $active={active} $select={select} onClick={(e)=> {
            if(ClickFunction){
                e.preventDefault()
                ClickFunction()
            }
        }} href={page}>
            {childs.length>0?
                childs.map(child=>(child))
            :
                <>
                    <MenuIcon src={icon} fill={active ? '#F2F2F2' : '#A3A3A3'}/>
                    {text}
                </>
            }
        </ItemButton>
    );
}

export default ItemContainer;
